"use strict";

var _defineProperty = require("/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/defineProperty.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
function processProperties(properties, formPayload) {
  return Object.keys(properties).reduce(function (acc, key) {
    var value = properties[key];
    var referenceBase = 'field-value:';
    var referenceAnotherField = typeof value === 'string' && value.indexOf(referenceBase) === 0;
    if (referenceAnotherField) {
      var refFieldSlug = value.replace(referenceBase, '');
      var hasRefField = Object.keys(formPayload).includes(refFieldSlug);
      if (!hasRefField) return Object.assign({}, acc);
      var referencedValue = formPayload[refFieldSlug];
      return Object.assign(Object.assign({}, acc), _defineProperty({}, key, referencedValue));
    } else {
      return Object.assign(Object.assign({}, acc), _defineProperty({}, key, value));
    }
  }, {});
}
exports.default = processProperties;